export default "/images/1f782f1d0d723d01b6f9604a29e627c1.avif";